import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight } from 'lucide-react';
interface SampleRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SampleRequestModal({
  isOpen,
  onClose
}: SampleRequestModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-479">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[60] transition-opacity" data-id="element-480" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-481">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden pointer-events-auto flex flex-col max-h-[90vh]" data-id="element-482">
              {/* Header */}
              <div className="px-6 py-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-483">
                <h2 className="text-xl font-bold text-[#0A1628]" data-id="element-484">
                  Request Sample Pack
                </h2>
                <button onClick={onClose} className="p-2 text-slate-400 hover:text-[#0A1628] hover:bg-slate-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-485">
                  <X className="h-5 w-5" data-id="element-486" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="p-6 overflow-y-auto" data-id="element-487">
                <p className="text-slate-500 mb-6 text-sm leading-relaxed" data-id="element-488">
                  Enter your details below to receive a free sample pack of our
                  most popular industrial labels and materials.
                </p>

                <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-489">
                  <div className="space-y-1.5" data-id="element-490">
                    <label htmlFor="name" className="block text-sm font-semibold text-[#0A1628]" data-id="element-491">
                      Full Name
                    </label>
                    <input type="text" id="name" required placeholder="e.g. John Smith" className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC] transition-all" data-id="element-492" />
                  </div>

                  <div className="space-y-1.5" data-id="element-493">
                    <label htmlFor="email" className="block text-sm font-semibold text-[#0A1628]" data-id="element-494">
                      Work Email
                    </label>
                    <input type="email" id="email" required placeholder="john@company.com" className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC] transition-all" data-id="element-495" />
                  </div>

                  <div className="space-y-1.5" data-id="element-496">
                    <label htmlFor="phone" className="block text-sm font-semibold text-[#0A1628]" data-id="element-497">
                      Telephone
                    </label>
                    <input type="tel" id="phone" required placeholder="+44 123 456 7890" className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC] transition-all" data-id="element-498" />
                  </div>

                  <div className="space-y-1.5" data-id="element-499">
                    <label htmlFor="address" className="block text-sm font-semibold text-[#0A1628]" data-id="element-500">
                      Delivery Address
                    </label>
                    <textarea id="address" required rows={3} placeholder="Company name, street, city, postcode..." className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC] transition-all resize-none" data-id="element-501" />
                  </div>

                  <div className="pt-2" data-id="element-502">
                    <button type="submit" className="w-full py-3.5 bg-[#0052CC] text-white font-bold rounded-full hover:bg-[#0040A0] transition-all duration-200 flex items-center justify-center shadow-lg shadow-[#0052CC]/20 hover:shadow-xl hover:shadow-[#0052CC]/30 hover:-translate-y-0.5" data-id="element-503">
                      Request sample pack
                      <ArrowRight className="ml-2 h-4 w-4" data-id="element-504" />
                    </button>
                  </div>

                  <p className="text-xs text-center text-slate-400" data-id="element-505">
                    We'll process your request within 24 hours.
                  </p>
                </form>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}